// Prometheus 查询辅助模块（经壳页 nginx 反代 /prom，同源零 CORS）
// 只开放 query + query_range 两个路径，其他 /prom/* 404

const BASE = "/prom/api/v1";

async function fetchJSON(url) {
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) throw new Error("HTTP " + res.status);
  return res.json();
}

// 瞬时查询：query = PromQL 表达式
// 返回 [{metric, value:[ts, valStr]}, ...]；失败/空返回 []
export async function query(expr) {
  try {
    const j = await fetchJSON(`${BASE}/query?query=${encodeURIComponent(expr)}`);
    if (j.status !== "success") return [];
    return (j.data && j.data.result) || [];
  } catch (e) {
    console.warn("prom query fail:", expr, e.message);
    return [];
  }
}

// 区间查询：expr + 起止秒 + 步长秒
export async function queryRange(expr, startSec, endSec, stepSec) {
  try {
    const url =
      `${BASE}/query_range?query=${encodeURIComponent(expr)}` +
      `&start=${startSec}&end=${endSec}&step=${stepSec}`;
    const j = await fetchJSON(url);
    if (j.status !== "success") return [];
    return (j.data && j.data.result) || [];
  } catch (e) {
    console.warn("prom query_range fail:", expr, e.message);
    return [];
  }
}

// 取第一个结果的数值（瞬时查询）；无数据返回 null
export async function firstValue(expr) {
  const r = await query(expr);
  if (!r.length) return null;
  return parseFloat(r[0].value[1]);
}

// 当前 unix 秒
export function nowSec() {
  return Math.floor(Date.now() / 1000);
}

// 格式化时间 HH:MM
export function fmtHM(tsSec) {
  const d = new Date(tsSec * 1000);
  const p = n => (n < 10 ? "0" + n : "" + n);
  return p(d.getHours()) + ":" + p(d.getMinutes());
}
